<template>
    <div v-lazy:background-image="backgroundImage" class="hosts-landing">
        <div class="content">
            <div class="when">7. 9. - 8. 9. 2019.</div>
            <div class="where">Zámek Třebušín</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SectionHostsLanding",
        computed: {
            backgroundImage() {
                return {
                    src: '/images/predsvatebni/A&D_107.jpg',
                    loading: '/images/predsvatebni/thumbnails/t_A&D_107.jpg',
                    preLoad: 250 / 166
                }
            }
        },
    };
</script>
<style scoped lang="stylus">
    .hosts-landing {
        position: relative;

        background-size: cover;
        background-position: center 35%;
        height: 100vh
    }
    .content {
        position: absolute;
        width: 100%;
        height: 100%;

        padding: 0 5vw;

        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: flex-end;
        font-size: 3rem;
    }

    .where, .who, .when {
        color: var(--v-secondary-base);
        text-shadow: 2px 2px #000000;
    }

    .where {
        font-size: 10vw;
    }

    .when {
        font-size: 5vw;
    }

    @media screen and (max-width: 960px) {
        .content {
            justify-content: flex-end;
            align-items: center;
            padding-bottom: 2rem;
        }
        .where {
            font-size: 13vw;
        }
        .when {
            font-size: 8.5vw;
        }
    }
</style>